module.exports = __webpack_public_path__ + "fonts/ab4a5ea7b67c74de76a88b85f6ca2ff5.ttf";